/**
 * Staging environment indicator.
 *
 * Renders a small orange "notch" pinned to the top-center of the viewport
 * (think MacBook camera notch) when running on a non-production hostname.
 * Production (myruby.me) shows nothing. Same code in both environments —
 * differentiated purely by runtime hostname check.
 *
 * Positioned `fixed` so it floats over content and consumes no layout
 * height. `pointer-events-none` so it never intercepts clicks on anything
 * rendered underneath (page headers tend to live in that strip).
 */

const PRODUCTION_HOSTNAMES = ['myruby.me', 'www.myruby.me'];

function isStaging(): boolean {
  return !PRODUCTION_HOSTNAMES.includes(window.location.hostname);
}

export function StagingBanner() {
  if (!isStaging()) return null;

  return (
    <div
      className="pointer-events-none fixed left-1/2 top-0 z-50 -translate-x-1/2 select-none rounded-b-md bg-orange-500 px-3 py-0.5 text-[10px] font-semibold tracking-wider text-white shadow-sm"
      aria-label="Staging environment"
    >
      STAGING
    </div>
  );
}

/** Returns true if the current environment is staging (non-production). */
export function isStagingEnv(): boolean {
  return isStaging();
}
